<template>
    <div class="w-100 flex-grow-1 bd-highlight d-flex flex-column align-items-end pl-4" v-if="!loadingGroupCallbacks">
      <template v-if="groupCallbacks.length > 0">
        <div class="text-right">
          <a href="#" class="delete-link" @click="removeAllCallbacks">{{ $t('views.seller.integrations.config.card.remove_all') }}</a>
        </div>
        <div v-for="(callback, i) in groupCallbacks" class="card-integration mb-2" :key="i">
          <div class="row">
            <div class="col-10">
              <strong class="d-block text-truncate product">{{ callback.product_name }}</strong>
              <span class="d-block text-truncate url">{{ callback.url }}</span>
            </div>
            <div class="col-2 d-flex align-items-center justify-content-end actions">
              <button class="action_button action_button__edit" @click="showEditCallback(callback, i)">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14.0002 8C13.8234 8 13.6538 8.07024 13.5288 8.19526C13.4037 8.32029 13.3335 8.48986 13.3335 8.66667V12.6667C13.3335 12.8435 13.2633 13.013 13.1382 13.1381C13.0132 13.2631 12.8436 13.3333 12.6668 13.3333H3.3335C3.15669 13.3333 2.98712 13.2631 2.86209 13.1381C2.73707 13.013 2.66683 12.8435 2.66683 12.6667V3.33333C2.66683 3.15652 2.73707 2.98695 2.86209 2.86193C2.98712 2.7369 3.15669 2.66667 3.3335 2.66667H7.3335C7.51031 2.66667 7.67988 2.59643 7.8049 2.4714C7.92992 2.34638 8.00016 2.17681 8.00016 2C8.00016 1.82319 7.92992 1.65362 7.8049 1.5286C7.67988 1.40357 7.51031 1.33333 7.3335 1.33333H3.3335C2.80306 1.33333 2.29436 1.54405 1.91928 1.91912C1.54421 2.29419 1.3335 2.8029 1.3335 3.33333V12.6667C1.3335 13.1971 1.54421 13.7058 1.91928 14.0809C2.29436 14.456 2.80306 14.6667 3.3335 14.6667H12.6668C13.1973 14.6667 13.706 14.456 14.081 14.0809C14.4561 13.7058 14.6668 13.1971 14.6668 12.6667V8.66667C14.6668 8.48986 14.5966 8.32029 14.4716 8.19526C14.3465 8.07024 14.177 8 14.0002 8ZM4.00016 8.50667V11.3333C4.00016 11.5101 4.0704 11.6797 4.19543 11.8047C4.32045 11.9298 4.49002 12 4.66683 12H7.4935C7.58123 12.0005 7.66821 11.9837 7.74943 11.9505C7.83066 11.9173 7.90454 11.8685 7.96683 11.8067L12.5802 7.18667L14.4735 5.33333C14.536 5.27136 14.5856 5.19762 14.6194 5.11638C14.6533 5.03515 14.6707 4.94801 14.6707 4.86C14.6707 4.77199 14.6533 4.68485 14.6194 4.60362C14.5856 4.52238 14.536 4.44864 14.4735 4.38667L11.6468 1.52667C11.5849 1.46418 11.5111 1.41458 11.4299 1.38074C11.3486 1.34689 11.2615 1.32947 11.1735 1.32947C11.0855 1.32947 10.9984 1.34689 10.9171 1.38074C10.8359 1.41458 10.7621 1.46418 10.7002 1.52667L8.82016 3.41333L4.1935 8.03333C4.13171 8.09563 4.08283 8.1695 4.04965 8.25073C4.01647 8.33195 3.99966 8.41893 4.00016 8.50667ZM11.1735 2.94L13.0602 4.82667L12.1135 5.77333L10.2268 3.88667L11.1735 2.94ZM5.3335 8.78L9.28683 4.82667L11.1735 6.71333L7.22016 10.6667H5.3335V8.78Z" fill="#6B7280"/>
                </svg>
              </button>
              <button class="action_button action_button__delete" @click="removeCallback(callback, i)">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6.66667 12C6.84348 12 7.01305 11.9298 7.13807 11.8047C7.2631 11.6797 7.33333 11.5102 7.33333 11.3333V7.33334C7.33333 7.15653 7.2631 6.98696 7.13807 6.86194C7.01305 6.73692 6.84348 6.66668 6.66667 6.66668C6.48986 6.66668 6.32029 6.73692 6.19526 6.86194C6.07024 6.98696 6 7.15653 6 7.33334V11.3333C6 11.5102 6.07024 11.6797 6.19526 11.8047C6.32029 11.9298 6.48986 12 6.66667 12ZM13.3333 4.00001H10.6667V3.33334C10.6667 2.80291 10.456 2.2942 10.0809 1.91913C9.70581 1.54406 9.1971 1.33334 8.66667 1.33334H7.33333C6.8029 1.33334 6.29419 1.54406 5.91912 1.91913C5.54405 2.2942 5.33333 2.80291 5.33333 3.33334V4.00001H2.66667C2.48986 4.00001 2.32029 4.07025 2.19526 4.19527C2.07024 4.3203 2 4.48987 2 4.66668C2 4.84349 2.07024 5.01306 2.19526 5.13808C2.32029 5.26311 2.48986 5.33334 2.66667 5.33334H3.33333V12.6667C3.33333 13.1971 3.54405 13.7058 3.91912 14.0809C4.29419 14.456 4.8029 14.6667 5.33333 14.6667H10.6667C11.1971 14.6667 11.7058 14.456 12.0809 14.0809C12.456 13.7058 12.6667 13.1971 12.6667 12.6667V5.33334H13.3333C13.5101 5.33334 13.6797 5.26311 13.8047 5.13808C13.9298 5.01306 14 4.84349 14 4.66668C14 4.48987 13.9298 4.3203 13.8047 4.19527C13.6797 4.07025 13.5101 4.00001 13.3333 4.00001ZM6.66667 3.33334C6.66667 3.15653 6.7369 2.98696 6.86193 2.86194C6.98695 2.73691 7.15652 2.66668 7.33333 2.66668H8.66667C8.84348 2.66668 9.01305 2.73691 9.13807 2.86194C9.2631 2.98696 9.33333 3.15653 9.33333 3.33334V4.00001H6.66667V3.33334ZM11.3333 12.6667C11.3333 12.8435 11.2631 13.0131 11.1381 13.1381C11.013 13.2631 10.8435 13.3333 10.6667 13.3333H5.33333C5.15652 13.3333 4.98695 13.2631 4.86193 13.1381C4.7369 13.0131 4.66667 12.8435 4.66667 12.6667V5.33334H11.3333V12.6667ZM9.33333 12C9.51014 12 9.67971 11.9298 9.80474 11.8047C9.92976 11.6797 10 11.5102 10 11.3333V7.33334C10 7.15653 9.92976 6.98696 9.80474 6.86194C9.67971 6.73692 9.51014 6.66668 9.33333 6.66668C9.15652 6.66668 8.98695 6.73692 8.86193 6.86194C8.73691 6.98696 8.66667 7.15653 8.66667 7.33334V11.3333C8.66667 11.5102 8.73691 11.6797 8.86193 11.8047C8.98695 11.9298 9.15652 12 9.33333 12Z" fill="#6B7280"/>
                </svg>
              </button>
            </div>
          </div>
          <div class="mt-2 items-list">
            <template v-for="(event, n) in callback.triggers">
              <div class="item-box" :key="n" v-if="n < 5">
                <span class="text-nowrap">
                  {{ getNameEvent(event.trigger) }}
                </span>
              </div>
            </template>
            <div class="item-box" v-if="callback.triggers.length > 5">
              <span class="text-nowrap limit">+{{ callback.triggers.length - 5 }}</span>
            </div>
          </div>
          <b-overlay :show="callback.loading" no-wrap></b-overlay>
        </div>
      </template>
      <template v-else>
        <div class="card-integration text-center px-4 py-5">{{ $t('views.seller.integrations.config.card.no_content') }}</div>
      </template>
    </div>
  </template>
  
  <script>
  
  import Vue from 'vue';
  import CallbackService from '@/services/resources/CallbackService';
  
  export default {
    name: "IntegrationsConfigListTheMembers",
    props: {
      integration: {
        type: Object,
        default: () => {},
        required: true,
      },
      loadingGroupCallbacks: {
        type: Boolean,
        default: false,
        required: true,
      },
      showEditCallback: {
        type: Function,
        default: () => {},
        required: true,
      },
      events: {
        type: Object,
        default: () => {},
        required: true,
      }
    },
    data: () => {
      return {
        groupCallbacks: [],
      }
    },
    watch: {
      'integration.id'(newId) {
        if (newId) {
          this.fetchCallbacks();
        }
      }
    },
    methods: {
      fetchCallbacks() {
        this.$emit('update:loadingGroupCallbacks', true);
        CallbackService.build().read(`integrations/group/${this.integration.id}`)
        .then(response => {
          this.groupCallbacks = response;
        })
        .finally(() => {
          this.$emit('update:loadingGroupCallbacks', false);
        });
      },
      getNameEvent(event) {
  
        const allOptions = [
          ...this.events.options_sales,
          ...this.events.options_contracts,
          ...this.events.options_sales_recovery
        ];
  
        const nameEvent = allOptions.find(e => e.value === event);
  
        return nameEvent?.text || event;
      },
      removeCallback(data, index) {
        Vue.swal({
          title: this.$t('views.seller.integrations.config.alert.remove.title'),
          html: `<p>${this.$t('views.seller.integrations.config.alert.remove.message')}</p>
          <ul>
            <li>${data.product_name}</li>
          </ul>`,
          showCloseButton: true,
          showCancelButton: true,
          confirmButtonText: this.$t('views.seller.integrations.config.alert.remove.ok'),
          cancelButtonText: this.$t('views.seller.integrations.config.alert.remove.cancel'),
          customClass: "sweet-container-new",
          confirmButtonClass: "btn btn-danger",
          cancelButtonClass: "btn btn-outline-secondary",
          buttonsStyling: false,
          reverseButtons: true,
        }).then((result) => {
          if (result.isConfirmed) {
            this.$set(this.groupCallbacks[index], 'loading', true);
            const encodedURL = encodeURIComponent(data.url);
            CallbackService.build().destroy({
              id: `integrations/group/${this.integration.id}/${data.product_id}?url=${encodedURL}`
            })
            .then(() => {
              this.groupCallbacks.splice(index, 1);
              this.$bvToast.toast(this.$t('views.seller.integrations.config.toast.remove.success.message'), {
                title: this.$t('views.seller.integrations.config.toast.remove.success.title'),
                variant: "success",
                autoHideDelay: 5000,
                appendToast: true,
              });
            })
            .catch(err => {
              this.groupCallbacks[index].loading = false;
            });
          }
        });
      },
      removeAllCallbacks() {
        Vue.swal({
          title: this.$t('views.seller.integrations.config.alert.remove_all.title'),
          html: `<p>${this.$t('views.seller.integrations.config.alert.remove_all.message')} ${this.integration.name}?</p>`,
          showCancelButton: true,
          showCloseButton: true,
          confirmButtonText: this.$t('views.seller.integrations.config.alert.remove_all.ok'),
          cancelButtonText: this.$t('views.seller.integrations.config.alert.remove_all.cancel'),
          customClass: "sweet-container-new",
          confirmButtonClass: "btn btn-danger",
          cancelButtonClass: "btn btn-outline-secondary",
          buttonsStyling: false,
          reverseButtons: true,
        }).then((result) => {
          if (result.isConfirmed) {
            this.$emit('update:loadingGroupCallbacks', true);
            CallbackService.build().destroy({
              id: `integrations/group/${this.integration.id}/remove/all`
            })
            .then(() => {
              this.fetchCallbacks();
              this.$bvToast.toast(this.$t('views.seller.integrations.config.toast.remove_all.success.message'), {
                title: this.$t('views.seller.integrations.config.toast.remove_all.success.title'),
                variant: "success",
                autoHideDelay: 5000,
                appendToast: true,
              });
            })
            .catch(() => {
              this.$emit('update:loadingGroupCallbacks', false);
            });
          }
        });
      },
    }
  }
  </script>